module.exports = __webpack_public_path__ + "static/img/four.fc42efce.png";